import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Paper
} from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import {
  WorkspacePremium as PremiumIcon,
  LiveTv as LiveTvIcon,
  Assignment as AssignmentIcon,
  CalendarMonth as CalendarIcon
} from '@mui/icons-material';

const FreeUserNotice = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <LiveTvIcon sx={{ fontSize: 40, color: '#F5A623' }} />,
      titleKey: 'freeUserNotice.features.liveClasses.title',
      descriptionKey: 'freeUserNotice.features.liveClasses.description'
    },
    {
      icon: <AssignmentIcon sx={{ fontSize: 40, color: '#F5A623' }} />,
      titleKey: 'freeUserNotice.features.assignments.title',
      descriptionKey: 'freeUserNotice.features.assignments.description'
    },
    {
      icon: <CalendarIcon sx={{ fontSize: 40, color: '#F5A623' }} />,
      titleKey: 'freeUserNotice.features.schedule.title',
      descriptionKey: 'freeUserNotice.features.schedule.description'
    }
  ];

  return (
        <>
          <Container 
            maxWidth={false} 
            sx={{
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
              background: 'linear-gradient(145deg, #FAFAFA 0%, #FAFAFA 100%)',
              position: 'relative',
              px: 0
            }}
          >
            <Paper
              elevation={0}
              sx={{
                backgroundColor: '#fff',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid #eee',
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                px: 2,
                py: 1.5,
                borderRadius: 0
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PremiumIcon sx={{ color: '#F5A623', fontSize: 28 }} />
                <Typography variant="h6" sx={{ color: '#1a1a1a', fontWeight: 600 }}>
                  {t('freeUserNotice.title')}
                </Typography>
              </Box>
            </Paper>

            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              sx={{
                width: '100%',
                maxWidth: '800px',
                mx: 'auto',
                px: 2,
                py: 4,
                flex: 1,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: '#666',
                  fontSize: '0.95rem',
                  mb: 4,
                  textAlign: 'center'
                }}
              >
                {t('freeUserNotice.message')}
              </Typography>

              <Grid container spacing={3}>
                {features.map((feature, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <Card 
                      component={motion.div}
                      whileHover={{ y: -4 }}
                      sx={{ 
                        height: '100%',
                        backgroundColor: '#fff',
                        border: '1px solid #eee',
                        '&:hover': {
                          borderColor: '#F5A623'
                        }
                      }}
                    >
                      <CardContent sx={{ p: 3, textAlign: 'center' }}>
                        <Box sx={{ mb: 2 }}>
                          {feature.icon}
                        </Box>
                        <Typography 
                          variant="h6" 
                          sx={{ 
                            fontWeight: 600,
                            mb: 1,
                            color: '#1a1a1a'
                          }}
                        >
                          {t(feature.titleKey)}
                        </Typography>
                        <Typography 
                          variant="body2"
                          sx={{ 
                            color: '#666'
                          }}
                        >
                          {t(feature.descriptionKey)}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Container>
        </>
  );
};

export default FreeUserNotice;